import { RouterModule } from '@angular/router';
import { appRoutePaths } from './../../../app.paths';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiTooltipModule } from 'omnium-ui/tooltip';
import { normalizeValue } from '../../../features/applications/shared/common.utils';
import { TagStatus } from '../../../features/applications/shared/investor-status-tag/investor-status-tag.component';

@Component({
  selector: 'dbw-investor-card',
  imports: [RouterModule, OuiIconModule, OuiTooltipModule],
  templateUrl: './investor-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './investor-card.component.scss',
})
export class InvestorCardComponent {
  readonly id = input.required<number>();
  readonly code = input.required<string>();
  readonly name = input.required<string>();
  readonly statusCode = input<string | null | undefined>(undefined);

  readonly link = computed(() => appRoutePaths.atlas.investor(this.id()));
  readonly statusLabel = computed(() => {
    const value = this.statusCode()?.trim();
    const normalized = normalizeValue(value);

    switch (normalized) {
      case 'CLIENT':
        return 'Client';
      case 'PROSPECT':
        return 'Prospect';
      case 'CONTACT':
        return 'Contact';
      case 'SUPPRIME':
        return 'Supprimé';
      default:
        return value || 'Statut non renseigne';
    }
  });

  readonly tagStatus = computed<TagStatus>(() => {
    const normalized = normalizeValue(this.statusCode());

    switch (normalized) {
      case 'CLIENT':
        return 'completed';
      case 'PROSPECT':
        return 'transition';
      case 'CONTACT':
        return 'pending';
      case 'SUPPRIME':
        return 'error';
      default:
        return 'pending';
    }
  });
}
